/**
 * Test IDs for QA automation.
 */
export const testIds = {
  hourlyForecastModelFormAddSlotNavigation: "hourly-forecast-model-form-add-slot-navigation",
  hourlyForecastModelFormAddSlotView: "hourly-forecast-model-form-add-slot-view",
  hourlyForecastModelFormRemoveSlot: "hourly-forecast-model-form-remove-slot",
} as const;
